// import { config } from 'dotenv';
// config();

const configuration = {
  // API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  
  API_BASE_URL: "https://solid-setup-473716-t1.el.r.appspot.com"
  
  
  // API_BASE_URL:"http://localhost:8080"
 
};

export default configuration;

